import React from 'react';

function SvgEchIconInfoI(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={78.28}
          y1={78.28}
          x2={21.72}
          y2={21.72}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <linearGradient
          id={`${iconUuid}_b`}
          x1={59.34}
          y1={67.97}
          x2={40.66}
          y2={49.29}
          xlinkHref={`#${iconUuid}_a`}
        />
        <linearGradient
          id={`${iconUuid}_c`}
          x1={54.24}
          y1={39}
          x2={45.76}
          y2={30.51}
          xlinkHref={`#${iconUuid}_a`}
        />
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M50,10A40,40,0,1,0,90,50,40,40,0,0,0,50,10Zm0,78.5A38.5,38.5,0,1,1,88.5,50,38.54,38.54,0,0,1,50,88.5Z"
      />
      <path
        fill={`url(#${iconUuid}_b)`}
        stroke={`url(#${iconUuid}_b)`}
        strokeWidth={5}
        d="M44.94,72.26H55.06V45H44.94Zm1.5-25.76h7.12V70.76H46.44Z"
      />
      <path
        fill={`url(#${iconUuid}_c)`}
        stroke={`url(#${iconUuid}_c)`}
        strokeWidth={5}
        d="M50,28.76a6,6,0,1,0,6,6A6,6,0,0,0,50,28.76Zm0,10.5a4.5,4.5,0,1,1,4.5-4.5A4.51,4.51,0,0,1,50,39.26Z"
      />
    </svg>
  );
}
export default SvgEchIconInfoI;
